// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1IpE0","errorLogs":"styles_errorLogs__3a596"};